import { Dialog, DialogContent } from 'design-system';

import { MonthlyRecapArticleDialog } from '@/features/markets/components/MarketArticlesModal/MonthlyRecapArticleDialog';
import type { MonthlyRecapsArticle } from '@/features/monthly-recaps';

type MonthlyRecapArticleModalProps = {
  article: MonthlyRecapsArticle;
  onClose: () => void;
};

export const MonthlyRecapArticleModal = ({ article, onClose }: MonthlyRecapArticleModalProps) => (
  <Dialog
    open
    onOpenChange={isOpen => {
      if (!isOpen) onClose();
    }}
  >
    <DialogContent
      showCloseButton={false}
      className='inset-0 top-0 left-0 flex h-screen max-h-screen w-screen max-w-none translate-x-0 translate-y-0 flex-col items-stretch justify-center rounded-none bg-gx-main-background p-0 sm:max-w-none!'
    >
      <MonthlyRecapArticleDialog
        article={article}
        onBack={onClose}
        onClose={onClose}
      />
    </DialogContent>
  </Dialog>
);
